module.exports = __webpack_public_path__ + "img/zk-icon-generalize.c49636c9.svg";